module.exports = __webpack_public_path__ + "static/media/xTRI.bcddf4bd.svg";